import React, { useState, useEffect } from 'react';

const PerfDashboardPage = () => {
  const [status, setStatus] = useState(null);
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    fetch('/api/perf-dashboard/status', {
      headers: { Authorization: `Bearer ${localStorage.getItem('okta-token-storage') ? JSON.parse(localStorage.getItem('okta-token-storage'))?.accessToken?.accessToken : ''}` },
    })
      .then((r) => r.json())
      .then(setStatus)
      .catch(() => setStatus({ status: 'error', error: 'Failed to check status' }));
  }, [starting]);

  const handleStart = async () => {
    setStarting(true);
    try {
      const token = JSON.parse(localStorage.getItem('okta-token-storage') || '{}')?.accessToken?.accessToken;
      await fetch('/api/perf-dashboard/start', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      // Wait for Flask to be ready
      await new Promise((r) => setTimeout(r, 4000));
    } catch {
      // ignore
    }
    setStarting(false);
  };

  const isRunning = status?.status === 'running';

  if (!status) {
    return (
      <div style={styles.container}>
        <div style={styles.loading}>⏳ Checking dashboard status...</div>
      </div>
    );
  }

  if (!isRunning) {
    return (
      <div style={styles.container}>
        <div style={styles.startPanel}>
          <a href="/" style={styles.backLink}>← Back to Lyric</a>
          <h2 style={styles.title}>📊 AI Performance Dashboard</h2>
          <p style={styles.subtitle}>The dashboard server needs to be started.</p>
          {status?.error && <p style={styles.error}>{status.error}</p>}
          <button
            onClick={handleStart}
            disabled={starting}
            style={starting ? { ...styles.startBtn, opacity: 0.6 } : styles.startBtn}
          >
            {starting ? '⏳ Starting...' : '▶️ Start Dashboard'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.wrapper}>
      <div style={styles.toolbar}>
        <a href="/" style={styles.backLink}>← Back to Lyric</a>
        <span style={styles.toolbarTitle}>📊 AI Performance Dashboard</span>
        <span style={styles.statusBadge}>● Running on port {status.port}</span>
      </div>
      <iframe
        src="/_perf-dashboard/"
        title="AI Performance Dashboard"
        style={styles.iframe}
      />
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#f0f2f5',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '0.6rem 1.5rem',
    backgroundColor: '#CE0E2C',
    color: '#fff',
    flexShrink: 0,
  },
  backLink: {
    color: '#fff',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '4px',
    backgroundColor: 'rgba(255,255,255,0.15)',
  },
  toolbarTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    flex: 1,
  },
  statusBadge: {
    fontSize: '0.8rem',
    opacity: 0.85,
  },
  iframe: {
    flex: 1,
    border: 'none',
    width: '100%',
  },
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f0f2f5',
  },
  loading: {
    fontSize: '1.1rem',
    color: '#555',
  },
  startPanel: {
    textAlign: 'center',
    padding: '3rem',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    maxWidth: '400px',
  },
  title: {
    fontSize: '1.4rem',
    marginBottom: '0.5rem',
    color: '#1A1A2E',
  },
  subtitle: {
    fontSize: '0.95rem',
    color: '#666',
    marginBottom: '1.5rem',
  },
  error: {
    color: '#CE0E2C',
    fontSize: '0.85rem',
    marginBottom: '1rem',
  },
  startBtn: {
    padding: '12px 32px',
    fontSize: '1rem',
    fontWeight: 600,
    cursor: 'pointer',
    color: '#fff',
    backgroundColor: '#CE0E2C',
    border: 'none',
    borderRadius: '6px',
    transition: 'opacity 0.2s',
  },
};

export default PerfDashboardPage;
